import { Drawer, type DrawerProps } from '@src/shared/ui/layout';
import { styled, type CSSObject, type Theme } from '@src/shared/ui/theme';

type SidebarDrawerProps = DrawerProps & { hoverOpen?: boolean };

const openedMixin = (theme: Theme): CSSObject => ({
  width: theme.layout.sidebar.maxWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme: Theme): CSSObject => ({
  width: theme.layout.sidebar.minWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
});

const SidebarDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'hoverOpen',
})<SidebarDrawerProps>(({ theme, open, hoverOpen }) => ({
  ...(open ? openedMixin(theme) : closedMixin(theme)),
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.grey[100],
    boxShadow: '0px 16px 32px #17254c1f',
    overflowX: 'hidden',
    paddingTop: '20px',
    ...(open || hoverOpen ? openedMixin(theme) : closedMixin(theme)),
  },
}));

SidebarDrawer.displayName = 'SidebarDrawer';
export default SidebarDrawer;
